module.exports = __webpack_public_path__ + "static/img/Photography.9f9bc0a.png";